import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogOne from "../../Blogdetails/BlogOne";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="Top Career Opportunities After B.Pharm: What You Can Become"
        />
        <BlogOne />
      </section>
    </>
  );
}

export default Main;
